import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import userService from "../../../../api/Authentication/AuthenticationService";
export default class UpdateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvaliableUsers: [],
      selectedUser: {
        id: null,
        en_fullname: null,
        ar_fullname: null,
        email: null,
        company: null,
        dept: null,
        id_no: null,
        password: null,
        status: null,
        role: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllUsers();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getAllUsers = () => {
    this.setState({ allAvaliableUsers: [] });
    userService
      .getAllUsers()
      .then((res) => {
        console.log(res.data);
        res.data.map((user, i) => {
          return this.setState({
            allAvaliableUsers: [
              ...this.state.allAvaliableUsers,
              {
                key: i,
                id: user.id,
                en_fullname: user.en_fullname,
                ar_fullname: user.ar_fullname,
                email: user.email,
                company: user.company,
                dept: user.dept,
                id_no: user.id_no,
                password: user.password,
                status: user.status,
                role: user.role,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectUsers = () => {
    return this.state.allAvaliableUsers.map((user, index) => {
      return (
        <option key={index} value={user.id}>
          {user.en_fullname}
        </option>
      );
    });
  };

  onSelectUser = (e) => {
    this.state.allAvaliableUsers.map((user, index) => {
      console.log(e.target.value, user.id);
      // if (e.target.value === user.id) alert("match", user.id);
      e.target.value === user.id &&
        this.setState({
          selectedUser: {
            key: index,
            id: user.id,
            en_fullname: user.en_fullname,
            ar_fullname: user.ar_fullname,
            email: user.email,
            company: user.company,
            dept: user.dept,
            id_no: user.id_no,
            password: "",
            status: user.status,
            role: user.role,
          },
        });
    });
  };

  updateUser = () => {
    console.log("updated user", this.state.selectedUser);
    userService.updateUser(this.state.selectedUser.id, {
      en_fullname: this.state.selectedUser.en_fullname,
      ar_fullname: this.state.selectedUser.ar_fullname,
      email: this.state.selectedUser.email,
      company: this.state.selectedUser.company,
      dept: this.state.selectedUser.dept,
      id_no: this.state.selectedUser.id_no,
      password: this.state.selectedUser.password,
      status: this.state.selectedUser.status,
      role: this.state.selectedUser.role,
    });
    document.getElementById("en_fullname").value = "";
    document.getElementById("ar_fullname").value = "";
    document.getElementById("password").value = "";
    document.getElementById("email").value = "";
    document.getElementById("dept").value = "";
    document.getElementById("id_no").value = "";
    document.getElementById("company").value = "";
    document.getElementById("role").selectedIndex = 0;
    document.getElementById("status").selectedIndex = 0;
    toast.success(`User Updated Successfuly`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllUsers();
  };

  onChangeUserData = (e) => {
    console.log(e.target.name, e.target.value);
    let selectedUser = this.state.selectedUser;
    selectedUser[e.target.name] = e.target.value;
    this.setState({ selectedUser });
  };

  onSelect = (name, e) => {
    let selectedUser = this.state.selectedUser;
    selectedUser[name] = e.target.value;
    this.setState({ selectedUser });
  };

  render() {
    let selectUsers = this.selectUsers();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update User</h5>
          </Col>
          <Col>
            <div className="form-group" id="role">
              <select
                className="form-control"
                id="role"
                onChange={this.onSelectUser}
              >
                <option value="#">Select User</option>
                {selectUsers}
              </select>
            </div>
          </Col>
        </Row>
        <Row form className="mt-4">
          <Col md="6" className="form-group">
            <FormGroup controlId="email" id="create-user">
              <label>English Name</label>
              <FormControl
                autoFocus
                type="text"
                name="en_fullname"
                id="en_fullname"
                onChange={this.onChangeUserData}
                defaultValue={this.state.selectedUser.en_fullname}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Arabic Name</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="text"
                name="ar_fullname"
                id="ar_fullname"
                defaultValue={this.state.selectedUser.ar_fullname}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Email</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="email"
                name="email"
                id="email"
                defaultValue={this.state.selectedUser.email}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Password</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="password"
                name="password"
                id="password"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Company</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="text"
                name="company"
                id="company"
                defaultValue={this.state.selectedUser.company}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>Department</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="text"
                name="dept"
                id="dept"
                defaultValue={this.state.selectedUser.dept}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup controlId="password" id="create-user">
              <label>ID Number</label>
              <FormControl
                onChange={this.onChangeUserData}
                type="text"
                name="id_no"
                id="id_no"
                defaultValue={this.state.selectedUser.id_no}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group pt-2 align-self-top">
            <div className="form-group" id="role">
              <label for="role">Role</label>
              <select
                className="form-control"
                id="role"
                name="role"
                onChange={(e) => this.onSelect("role", e)}
                defaultChecked={this.state.selectedUser.role}
              >
                <option value="#">Select Role</option>
                <option value="admin">Admin</option>
                <option value="moderator">Moderator</option>
                <option value="Employee">Employee</option>
              </select>
            </div>
          </Col>
          <Col md="6" className="form-group pt-2 align-self-top">
            <div className="form-group" id="role">
              <label for="role">Status</label>
              <select
                className="form-control"
                id="status"
                name="status"
                onChange={(e) => this.onSelect("status", e)}
                defaultChecked={this.state.selectedUser.status}
              >
                <option value="#">Select Status</option>
                <option value="active">Active</option>
                <option value="disable">Disable</option>
              </select>
            </div>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateUser}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
